import { PayloadAction } from '@reduxjs/toolkit';
import { ICreateProjectErrors, ProjectStateReducerCreator } from '../types';

const removeCreateProjectErrorFieldsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Partial<ICreateProjectErrors>>) => {
    if (state.createProjectErrors) {
      state.createProjectErrors = {
        ...state.createProjectErrors,
        ...action.payload /* spreading because it's <Partial> */,
      };
    }
  });
};

export default removeCreateProjectErrorFieldsReducer;
